import { lazy } from 'react';

import LazyRockPaperScissors from './RockPaperScissors/RockPaperScissors'
import LazyTicTacToe from './TicTacToe/TicTacToe';

// export const LazyRockPaperScissors = lazy(() => import('./RockPaperScissors/RockPaperScissors'));
// export const LazyTicTacToe = lazy(() => import('./TicTacToe/TicTacToe'));
// export const LazyMatchingTiles = lazy(() => import('./matching-tiles'));
// export const LazyGame2048 = lazy(() => import('./2048'));
// export const LazyMinesweeper = lazy(() => import('./minesweeper'));
// export const LazySudoku = lazy(() => import('./sudoku'));
// export const LazySnakeGame = lazy(() => import('./snake-game'));
// export const LazyBrickBreaker = lazy(() => import('./brick-breaker'));
// export const LazyDinoRun = lazy(() => import('./dino-run'));
// export const LazyFlappyBird = lazy(() => import('./flappy-bird-clone'));
// export const LazySolitaire = lazy(() => import('./solitaire'));
// export const LazyReversi = lazy(() => import('./reversi-othello'));
// export const LazyChess = lazy(() => import('./chess'));
// export const LazyLudo = lazy(() => import('./ludo'));
// export const LazyTowerDefense = lazy(() => import('./tower-defense'));
// export const LazyPoker = lazy(() => import('./poker')); 

export default { 
    LazyRockPaperScissors,
    LazyTicTacToe
}